// ignore-string-externalization

import { contentful } from '../lib/contentful';
import { WEBGATE_DOMAIN } from '../../../@mrkt/features/webgate-fetch';
import { setState } from './root';
import { ResponseError } from './utils/ResponseError';
import { DEFAULT_LOCALE } from '../lib/defaultLocale';

const key = 'heros';
const indexKey = 'heroIndex';

export const loadHeros =
  () => async (dispatch: $TSFixMe, getState: $TSFixMe) => {
    if (getState()[key]) {
      return;
    }

    const response = await contentful.getEntries(
      {
        content_type: 'headerImage',
        include: 10,
      },
      DEFAULT_LOCALE,
    );

    if (response.ok) {
      const json = await response.json();
      const artists = json.items
        .filter(Boolean)
        .map((item: $TSFixMe) => item.fields.artistId)
        .join(',');

      let publicData = {};
      try {
        publicData = await fetch(
          `${WEBGATE_DOMAIN}/s4x-insights-api/v1/artist/public-data?artists=${artists}`,
        ).then(res => res.ok && res.json());
      } catch (e) {
        /* ignore */
      }

      dispatch(
        setState({
          type: `${key}/LOAD`,
          payload: {
            [indexKey]: Math.floor(Math.random() * json.items.length),
            [key]: json.items.filter(Boolean).map((item: $TSFixMe) => ({
              listeners: (publicData as $TSFixMe)[item.fields.artistId],
              artistId: item.fields.artistId,
              artistName: item.fields.artistName,

              bannerImage: json.includes.Asset.find(
                (asset: $TSFixMe) =>
                  asset.sys.id === item.fields.bannerImage.sys.id,
              ).fields.file.url,
            })),
          },
        }),
      );
    } else {
      throw new ResponseError(response);
    }
  };

export const incrementHeroIndex =
  () => (dispatch: $TSFixMe, getState: $TSFixMe) => {
    const state = getState();
    const heros = state[key];
    const index = state[indexKey];

    if (!heros) {
      return;
    }

    let nextIndex = index + 1;

    if (nextIndex >= heros.length) {
      nextIndex = 0;
    }

    dispatch(
      setState({
        type: `${indexKey}/increment`,
        payload: {
          [indexKey]: nextIndex,
        },
      }),
    );
  };

export const selectHero = (state: $TSFixMe) =>
  state[key] && state[key][state[indexKey]];
